import { apiGet, apiPost } from '../../lib/apiClient'
import type { ICmlService } from './ICmlService.interface'
import type { CmlRef, CmlComparison, CmlDeployResult, CmlDependencyClosure, CmlDeployPreview } from '../../types/cml.types'

/** Real provider — calls /api/arm-data/cml/{list,compare,deploy} (see CmlService, host side). */
export class HttpCmlService implements ICmlService {
  list(connectionId: string): Promise<CmlRef[]> {
    return apiGet<{ items: CmlRef[] }>(`/api/arm-data/cml/list?connectionId=${encodeURIComponent(connectionId)}`)
      .then((r) => r.items)
  }

  compare(sourceConnectionId: string, targetConnectionId: string): Promise<CmlComparison> {
    return apiPost<CmlComparison>('/api/arm-data/cml/compare', { sourceConnectionId, targetConnectionId })
  }

  listBranch(input: { gitConnectionId: string; repo: string; branch: string }): Promise<CmlRef[]> {
    const q = new URLSearchParams({ gitConnectionId: input.gitConnectionId, repo: input.repo, branch: input.branch })
    return apiGet<{ items: CmlRef[] }>(`/api/arm-data/cml/list-branch?${q.toString()}`).then((r) => r.items)
  }

  compareBranch(input: { gitConnectionId: string; repo: string; branch: string; targetConnectionId: string }): Promise<CmlComparison> {
    return apiPost<CmlComparison>('/api/arm-data/cml/compare-branch', input)
  }

  compareToBranch(input: { sourceConnectionId: string; gitConnectionId: string; repo: string; branch: string }): Promise<CmlComparison> {
    return apiPost<CmlComparison>('/api/arm-data/cml/compare-to-branch', input)
  }

  compareBranchToBranch(input: { left: { gitConnectionId: string; repo: string; branch: string }; right: { gitConnectionId: string; repo: string; branch: string } }): Promise<CmlComparison> {
    return apiPost<CmlComparison>('/api/arm-data/cml/compare-branch-to-branch', input)
  }

  dependencies(input: { connectionId: string; esdDeveloperName: string; version?: number; targetConnectionId?: string }): Promise<CmlDependencyClosure> {
    const q = new URLSearchParams({ connectionId: input.connectionId, esdDeveloperName: input.esdDeveloperName })
    if (input.version !== undefined) q.set('version', String(input.version))
    if (input.targetConnectionId) q.set('targetConnectionId', input.targetConnectionId)
    return apiGet<CmlDependencyClosure>(`/api/arm-data/cml/dependencies?${q.toString()}`)
  }

  deploy(input: { sourceConnectionId: string; targetConnectionId: string; esdDeveloperName: string; version?: number }): Promise<CmlDeployResult> {
    return apiPost<CmlDeployResult>('/api/arm-data/cml/deploy', input)
  }

  preview(input: { sourceConnectionId: string; targetConnectionId: string; esdDeveloperName: string; version?: number }): Promise<CmlDeployPreview> {
    return apiPost<CmlDeployPreview>('/api/arm-data/cml/preview', input)
  }
}
